import React from "react";
import { ColumnManagement } from "../../hooks/useTableColumnConfig";

// Hands the column order and its handlers from `Table` to the columns panel, which MUI
// renders as a slot without access to the table's props.
export const ColumnManagementContext = React.createContext<ColumnManagement | null>(null);
